define('components-list',[
    "Components/AdvancedTemplatingWidget/js/AdvancedTemplatingWidget",
    "Components/AdvantageWidget/js/AdvantageWidget",
    "Components/BannerWidget/js/BannerWidget",
    "Components/BannerComeInWidget/js/BannerComeInWidget",
    "Components/CagnotteComeInWidget/js/CagnotteComeInWidget",
    "Components/CategoriesWidget/js/CategoriesWidget",
    "Components/Comein/js/Comein",
    "Components/CurrencySubunit/js/CurrencySubunit",
    "Components/Devatics/js/Devatics",
    "Components/EngagementsWidget/js/EngagementsWidget",
    "Components/GlossaryWidget/js/GlossaryWidget",
    "Components/IconWidget/js/IconWidget",
    "Components/InstagramWidget/js/InstagramWidget",
    "Components/Jobs/js/Jobs",
    "Components/LandingWidget/js/LandingWidget",
    "Components/Loyalty/js/Loyalty",
    "Components/MediaWidget/js/MediaWidget",
    "Components/MenuWidget/js/MenuWidget",
    "Components/NewsWidget/js/NewsWidget",
    "Components/OrderStatWidget/js/OrderStatWidget",
    "Components/PageHeaderWidget/js/PageHeaderWidget",
    "Components/ProductListWidget/js/ProductListWidget",
    "Components/ProductByShop/js/ProductByShop",
    "Components/PriceByShop/js/PriceByShop",
    "Components/ProductByShop/js/ProductByShop",
    "Components/ReinsuranceWidget/js/ReinsuranceWidget",
    "Components/RecrutementWidget/js/RecrutementWidget",
    "Components/ReorderWidget/js/ReorderWidget",
    "Components/RichTextWidget/js/RichTextWidget",
    "Components/StatusComeInWidget/js/StatusComeInWidget",
    "Components/SponsorshipWidget/js/SponsorshipWidget",
    "Components/SeparatorWidget/js/SeparatorWidget",
    "Components/StopSMSWidget/js/StopSMSWidget",
    "Components/TitleWidget/js/TitleWidget",
    "Components/Vod/js/Vod",
    "Components/AboutNavByDesireWidget/js/AboutNavByDesireWidget",
    "Components/ScrollPopinWidget/js/ScrollPopinWidget",
    "Components/JobWidget/js/JobWidget",
    "Components/OutdatedCampaignWidget/js/OutdatedCampaignWidget",
    "Components/VoucherSMSWidget/js/VoucherSMSWidget",
    "Components/AboutComeInWidget/js/AboutComeInWidget",
    "Components/AboutCornerWidget/js/AboutCornerWidget",
],function(){});
